import { FC } from 'react';
import footer from '@/assets/images/footer.jpg';
import { cn } from '@/lib/utils';
import { WidthOfPDF } from './PdfTemplate';

const PdfFooter: FC = () => {
  return (
    <div
      id="footer"
      data-html2canvas-ignore
      className={cn(
        'w-full h-[20px] flex justify-between items-center mx-auto bg-cover bg-footer-img',
        WidthOfPDF,
      )}
    >
      <div className={cn('w-full h-full relative', 'object-cover')}>
        <img
          className={cn('w-full h-full absolute object-cover')}
          src={footer}
        />
      </div>
    </div>
  );
};

export default PdfFooter;
